export const CRUISE_PRODUCT_TYPE = 'cruises'
export const FLIGHT_PRODUCT_TYPE = 'flights'
export const HOME_PRODUCT_TYPE = 'home'
export const HOTEL_PRODUCT_TYPE = 'hotels'
export const RENTAL_CAR_PRODUCT_TYPE = 'cars'
export const TRIPS_PRODUCT_TYPE = 'trips'
export const VACATIONS_PRODUCT_TYPE = 'vacations'
export const VACATION_PACKAGE_PRODUCT_TYPE = 'packages'
export const BUNDLE_AND_SAVE_PRODUCT_TYPE = 'bundle + save'
